/**
 * Utility to extract Availability error from the response JSON given the error id.
 * @param response	The AJAX response JSON.
 * @param errorId	The error id to look for.
 * @return			Returns the availability error message.
 */
function getAvailabilityErrorById (response, errorId) {

	const cartStatus = (response && response.CartStatus) || [];
	return _.indexOf(cartStatus, errorId) !== -1
		? response[window.lp.globals.isCustomerService ? 'ErrorMessages' : 'UserFriendlyErrorMessages']
		: '';

}

export default getAvailabilityErrorById;
